/**
 * @generated SignedSource<<ff78e5b60a05159ce63ed357e9de9f52>>
 * @relayHash e68741e9aa55c22f15fb45988e20f49c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 44e9841b592e24f4fe2f48f0cd28d8ceee782653f661bb001b3beae451fa106b

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceContentType = "ATTACHMENT" | "BLOG_POST" | "COMMENT" | "DATABASE" | "EMBED" | "FOLDER" | "PAGE" | "WHITEBOARD" | "%future added value";
export type ConfluencePageSubType = "LIVE" | "%future added value";
export type SearchCombinationType = "AND" | "OR" | "%future added value";
export type SearchConfluenceDocumentStatus = "ARCHIVED" | "CURRENT" | "DRAFT" | "%future added value";
export type SearchConfluenceRangeField = "CREATED" | "LASTMODIFIED" | "%future added value";
export type SearchContainerStatus = "ARCHIVED" | "CURRENT" | "%future added value";
export type SearchIssueStatusCategory = "DONE" | "INDETERMINATE" | "NEW" | "OPEN" | "UNDEFINED" | "%future added value";
export type SearchLinkedEntityGranularity = "ALL_MATCHING_MESSAGES" | "DEFAULT" | "FULL_THREAD" | "ONLY_LINKED_ENTITIES" | "%future added value";
export type SearchParticipantType = "COMMENTED" | "CONTRIBUTOR" | "MENTIONS" | "PRESENCE" | "SHARED" | "VIEWED" | "%future added value";
export type SearchProjectType = "business" | "customer_service" | "product_discovery" | "service_desk" | "software" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "organization" | "organization_status_update" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "risk" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
export type SearchThirdPartyRangeField = "CREATED" | "LASTMODIFIED" | "%future added value";
export type SearchAnalyticsInput = {
  queryVersion?: number | null;
  searchReferrerId?: string | null;
  searchSessionId?: string | null;
  sessionId?: string | null;
  sourceProduct?: string | null;
};
export type SearchFilterInput = {
  assetsFilters?: SearchAssetsFilter | null;
  commonFilters?: SearchCommonFilter | null;
  compassFilters?: SearchCompassFilter | null;
  confluenceFilters?: SearchConfluenceFilter | null;
  entities: ReadonlyArray<string>;
  externalFilters?: SearchExternalFilter | null;
  jiraFilters?: SearchJiraFilter | null;
  locations: ReadonlyArray<string>;
  mercuryFilters?: SearchMercuryFilter | null;
  talentFilters?: SearchTalentFilter | null;
  thirdPartyFilters?: SearchThirdPartyFilter | null;
  trelloFilters?: SearchTrelloFilter | null;
};
export type SearchAssetsFilter = {
  objectSchemaFilter?: SearchAssetsObjectSchemaFilter | null;
  objectTypeFilter?: SearchAssetsObjectTypeFilter | null;
};
export type SearchAssetsObjectSchemaFilter = {
  schemaARIs?: ReadonlyArray<string> | null;
};
export type SearchAssetsObjectTypeFilter = {
  typeARIs?: ReadonlyArray<string> | null;
};
export type SearchCommonFilter = {
  contributorsFilter?: ReadonlyArray<string> | null;
  participants?: SearchParticipants | null;
  range?: SearchCommonRangeFilter | null;
};
export type SearchParticipants = {
  combination: SearchCombinationType;
  items: ReadonlyArray<SearchParticipant>;
};
export type SearchParticipant = {
  combination: SearchCombinationType;
  type: SearchParticipantType;
  users: ReadonlyArray<string>;
};
export type SearchCommonRangeFilter = {
  created?: SearchCommonRangeFilterFields | null;
  lastModified?: SearchCommonRangeFilterFields | null;
};
export type SearchCommonRangeFilterFields = {
  gt?: string | null;
  lt?: string | null;
};
export type SearchCompassFilter = {
  componentFilter?: SearchCompassComponentFilter | null;
};
export type SearchCompassComponentFilter = {
  componentStates: ReadonlyArray<string>;
};
export type SearchConfluenceFilter = {
  ancestorIdsFilter?: ReadonlyArray<string> | null;
  containerARIs?: ReadonlyArray<string> | null;
  containerStatus?: ReadonlyArray<SearchContainerStatus | null> | null;
  contentStatuses?: ReadonlyArray<SearchConfluenceDocumentStatus> | null;
  contributorsFilter?: ReadonlyArray<string> | null;
  creatorsFilter?: ReadonlyArray<string> | null;
  isVerified?: boolean | null;
  labelsFilter?: ReadonlyArray<string> | null;
  mentions?: ReadonlyArray<string> | null;
  owners?: ReadonlyArray<string> | null;
  pageStatus?: ReadonlyArray<string> | null;
  range?: ReadonlyArray<SearchConfluenceRangeFilter | null> | null;
  spacesFilter?: ReadonlyArray<string> | null;
  titleMatchOnly?: boolean | null;
};
export type SearchConfluenceRangeFilter = {
  field: SearchConfluenceRangeField;
  gt?: string | null;
  lt?: string | null;
};
export type SearchExternalFilter = {
  containers?: ReadonlyArray<SearchExternalContainerFilter | null> | null;
  contentFormats?: ReadonlyArray<SearchExternalContentFormatFilter | null> | null;
  depth?: ReadonlyArray<SearchExternalDepthFilter | null> | null;
};
export type SearchExternalContainerFilter = {
  type: string;
  values: ReadonlyArray<string>;
};
export type SearchExternalContentFormatFilter = {
  type: string;
  values: ReadonlyArray<string>;
};
export type SearchExternalDepthFilter = {
  depth: number;
  type: string;
};
export type SearchJiraFilter = {
  boardFilter?: SearchBoardFilter | null;
  issueFilter?: SearchJiraIssueFilter | null;
  projectFilter?: SearchJiraProjectFilter | null;
};
export type SearchBoardFilter = {
  negateProjectFilter?: boolean | null;
  projectARI?: string | null;
  userARI?: string | null;
};
export type SearchJiraIssueFilter = {
  assigneeARIs?: ReadonlyArray<string> | null;
  commenterARIs?: ReadonlyArray<string> | null;
  issueLabels?: ReadonlyArray<string> | null;
  issueTypeIDs?: ReadonlyArray<string> | null;
  issueTypes?: ReadonlyArray<string> | null;
  projectARIs?: ReadonlyArray<string> | null;
  reporterARIs?: ReadonlyArray<string> | null;
  statusCategories?: ReadonlyArray<SearchIssueStatusCategory> | null;
  watcherARIs?: ReadonlyArray<string> | null;
};
export type SearchJiraProjectFilter = {
  projectType?: SearchProjectType | null;
  projectTypes?: ReadonlyArray<SearchProjectType> | null;
};
export type SearchMercuryFilter = {
  ancestorIds?: ReadonlyArray<string> | null;
  focusAreaTypeIds?: ReadonlyArray<string> | null;
  owners?: ReadonlyArray<string> | null;
};
export type SearchTalentFilter = {
  employmentTypes?: ReadonlyArray<string> | null;
  focusAreas?: ReadonlyArray<string> | null;
  jobFamilies?: ReadonlyArray<string> | null;
  owners?: ReadonlyArray<string> | null;
  statuses?: ReadonlyArray<string> | null;
  teams?: ReadonlyArray<string> | null;
};
export type SearchThirdPartyFilter = {
  additionalTexts?: ReadonlyArray<string> | null;
  ancestorAris?: ReadonlyArray<string> | null;
  assignees?: ReadonlyArray<string> | null;
  containerAris?: ReadonlyArray<string> | null;
  containerNames?: ReadonlyArray<string> | null;
  containerTypes?: ReadonlyArray<string> | null;
  createdBy?: ReadonlyArray<string> | null;
  excludeSubtypes?: ReadonlyArray<string> | null;
  gitFilters?: SearchGitFilters | null;
  integrations?: ReadonlyArray<string> | null;
  labels?: ReadonlyArray<string> | null;
  lastUpdatedBy?: ReadonlyArray<string> | null;
  range?: ReadonlyArray<SearchThirdPartyRangeFilter | null> | null;
  salesforceFilters?: SearchSalesforceFilters | null;
  subtypes?: ReadonlyArray<string | null> | null;
  teamsFilters?: SearchTeamsFilters | null;
  thirdPartyProducts?: ReadonlyArray<SearchThirdPartyProduct> | null;
  thirdPartyTypes?: ReadonlyArray<string> | null;
  titleMatchOnly?: boolean | null;
};
export type SearchGitFilters = {
  pullRequestStatus?: ReadonlyArray<string> | null;
  repoName?: ReadonlyArray<string> | null;
  reviewer?: ReadonlyArray<string> | null;
};
export type SearchThirdPartyRangeFilter = {
  field: SearchThirdPartyRangeField;
  gt?: string | null;
  lt?: string | null;
};
export type SearchSalesforceFilters = {
  campaignStatuses?: ReadonlyArray<string> | null;
  caseStatuses?: ReadonlyArray<string> | null;
  closeDate?: string | null;
  isClosed?: boolean | null;
  owners?: ReadonlyArray<string> | null;
  stage?: ReadonlyArray<string> | null;
};
export type SearchTeamsFilters = {
  attachmentFileTypes?: ReadonlyArray<string> | null;
  hasAttachment?: boolean | null;
  hasLink?: boolean | null;
  messageType?: string | null;
  workspaceName?: ReadonlyArray<string> | null;
};
export type SearchThirdPartyProduct = {
  channels?: ReadonlyArray<string | null> | null;
  connectionIds?: ReadonlyArray<string> | null;
  connectorSources?: ReadonlyArray<string> | null;
  connectorSourcesImpersonationEnabled?: ReadonlyArray<string> | null;
  containerTypes?: ReadonlyArray<string> | null;
  datasourceId?: string | null;
  entities?: ReadonlyArray<string> | null;
  integrationId?: string | null;
  linkedEntities?: ReadonlyArray<string> | null;
  linkedEntityGranularity?: SearchLinkedEntityGranularity | null;
  product?: string | null;
  providerId?: string | null;
  subtypes?: ReadonlyArray<string> | null;
};
export type SearchTrelloFilter = {
  isRecentBias?: boolean | null;
};
export type SearchExperimentContextInput = {
  experimentId?: string | null;
  experimentLayers?: ReadonlyArray<SearchExperimentLayer | null> | null;
  matchingLayerExperimentsMetadata?: SearchMatchingLayerExperimentsMetadata | null;
  shadowExperimentId?: string | null;
};
export type SearchExperimentLayer = {
  definitions?: ReadonlyArray<SearchLayerDefinition | null> | null;
  layerId?: string | null;
  name?: string | null;
  shadowId?: string | null;
};
export type SearchLayerDefinition = {
  abTestId?: string | null;
  connectorSources?: ReadonlyArray<string | null> | null;
  entity?: string | null;
  integrationARI?: string | null;
  layerId?: string | null;
  providerId?: string | null;
  shadowId?: string | null;
  statsigLayerId?: string | null;
  subEntity?: string | null;
};
export type SearchMatchingLayerExperimentsMetadata = {
  matchingLayers?: ReadonlyArray<SearchMatchingLayer | null> | null;
};
export type SearchMatchingLayer = {
  layerName?: string | null;
  layerType?: string | null;
};
export type useResultSupplierAdvancedAGGSearchQuery$variables = {
  after?: string | null;
  analytics?: SearchAnalyticsInput | null;
  experience: string;
  experimentContext?: SearchExperimentContextInput | null;
  filters: SearchFilterInput;
  first?: number | null;
  isLivePagesEnabled: boolean;
  query: string;
};
export type useResultSupplierAdvancedAGGSearchQuery$data = {
  readonly search: {
    readonly search: {
      readonly abTest: {
        readonly abTestId: string | null;
        readonly controlId: string | null;
        readonly experimentId: string | null;
      } | null;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly confluenceEntity?: {
            readonly ancestors?: ReadonlyArray<{
              readonly id: string;
              readonly links: {
                readonly webUi: string | null;
              } | null;
              readonly title: string | null;
            } | null> | null;
            readonly id?: string;
            readonly metadata?: {
              readonly titleEmojiPublished: {
                readonly id: string | null;
                readonly key: string | null;
                readonly value: string | null;
              } | null;
            } | null;
            readonly subtype?: ConfluencePageSubType | null;
            readonly type?: ConfluenceContentType | null;
          } | null;
          readonly entityId?: string | null;
          readonly excerpt?: string | null;
          readonly iconPath?: string | null;
          readonly id: string;
          readonly isVerified?: boolean;
          readonly key?: string | null;
          readonly lastModified?: string | null;
          readonly space?: {
            readonly id: string;
            readonly key: string | null;
            readonly name: string | null;
            readonly spaceId: string | null;
            readonly webUiLink: string | null;
          } | null;
          readonly title: string;
          readonly type: SearchResultType;
          readonly url: string;
          readonly webUiLink?: string | null;
        } | null;
      }>;
      readonly pageInfo: {
        readonly endCursor: string | null;
      };
      readonly totalCount: number | null;
    } | null;
  } | null;
};
export type useResultSupplierAdvancedAGGSearchQuery = {
  response: useResultSupplierAdvancedAGGSearchQuery$data;
  variables: useResultSupplierAdvancedAGGSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "analytics"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experience"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experimentContext"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLivePagesEnabled"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v8 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "analytics",
    "variableName": "analytics"
  },
  {
    "kind": "Variable",
    "name": "experience",
    "variableName": "experience"
  },
  {
    "kind": "Variable",
    "name": "experimentContext",
    "variableName": "experimentContext"
  },
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = {
  "kind": "ScalarField",
  "name": "title"
},
v11 = {
  "kind": "ScalarField",
  "name": "type"
},
v12 = {
  "kind": "ScalarField",
  "name": "url"
},
v13 = {
  "kind": "ScalarField",
  "name": "entityId"
},
v14 = {
  "kind": "ScalarField",
  "name": "excerpt"
},
v15 = {
  "kind": "ScalarField",
  "name": "isVerified"
},
v16 = {
  "kind": "ScalarField",
  "name": "lastModified"
},
v17 = {
  "kind": "ScalarField",
  "name": "key"
},
v18 = {
  "kind": "ScalarField",
  "name": "webUiLink"
},
v19 = {
  "concreteType": "SearchConfluenceResultSpace",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "ScalarField",
      "name": "spaceId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    (v17/*: any*/),
    (v18/*: any*/)
  ]
},
v20 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/),
    (v11/*: any*/),
    {
      "condition": "isLivePagesEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "subtype"
        }
      ]
    },
    {
      "concreteType": "ConfluencePage",
      "kind": "LinkedField",
      "name": "ancestors",
      "plural": true,
      "selections": [
        (v10/*: any*/),
        (v9/*: any*/),
        {
          "concreteType": "ConfluencePageLinks",
          "kind": "LinkedField",
          "name": "links",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "webUi"
            }
          ]
        }
      ]
    },
    {
      "concreteType": "ConfluenceContentMetadata",
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "concreteType": "ConfluenceContentTitleEmoji",
          "kind": "LinkedField",
          "name": "titleEmojiPublished",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v17/*: any*/),
            {
              "kind": "ScalarField",
              "name": "value"
            }
          ]
        }
      ]
    }
  ],
  "type": "ConfluencePage"
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    (v13/*: any*/),
    (v17/*: any*/),
    {
      "kind": "ScalarField",
      "name": "iconPath"
    },
    (v18/*: any*/)
  ],
  "type": "SearchConfluenceSpace"
},
v22 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v23 = {
  "concreteType": "SearchAbTest",
  "kind": "LinkedField",
  "name": "abTest",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "abTestId"
    },
    {
      "kind": "ScalarField",
      "name": "controlId"
    },
    {
      "kind": "ScalarField",
      "name": "experimentId"
    }
  ]
},
v24 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v25 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useResultSupplierAdvancedAGGSearchQuery",
    "selections": [
      {
        "concreteType": "SearchQueryAPI",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": [
          {
            "args": (v8/*: any*/),
            "concreteType": "SearchItemConnection",
            "kind": "LinkedField",
            "name": "search",
            "plural": false,
            "selections": [
              {
                "concreteType": "SearchResultItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v19/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "confluenceEntity",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/)
                            ]
                          }
                        ],
                        "type": "SearchConfluencePageBlogAttachment"
                      },
                      (v21/*: any*/)
                    ]
                  }
                ]
              },
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v7/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "useResultSupplierAdvancedAGGSearchQuery",
    "selections": [
      {
        "concreteType": "SearchQueryAPI",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": [
          {
            "args": (v8/*: any*/),
            "concreteType": "SearchItemConnection",
            "kind": "LinkedField",
            "name": "search",
            "plural": false,
            "selections": [
              {
                "concreteType": "SearchResultItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v25/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v19/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "confluenceEntity",
                            "plural": false,
                            "selections": [
                              (v25/*: any*/),
                              (v20/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v9/*: any*/)
                                ],
                                "type": "Node",
                                "abstractKey": "__isNode"
                              }
                            ]
                          }
                        ],
                        "type": "SearchConfluencePageBlogAttachment"
                      },
                      (v21/*: any*/)
                    ]
                  }
                ]
              },
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "e68741e9aa55c22f15fb45988e20f49c",
    "id": "44e9841b592e24f4fe2f48f0cd28d8ceee782653f661bb001b3beae451fa106b",
    "metadata": {},
    "name": "useResultSupplierAdvancedAGGSearchQuery",
    "operationKind": "query",
    "text": "query useResultSupplierAdvancedAGGSearchQuery($experience:String!,$analytics:SearchAnalyticsInput,$query:String!,$first:Int,$after:String,$filters:SearchFilterInput!,$experimentContext:SearchExperimentContextInput,$isLivePagesEnabled:Boolean!){search{search(experience:$experience,analytics:$analytics,query:$query,first:$first,after:$after,filters:$filters,experimentContext:$experimentContext){edges{node{__typename,id,title,type,url,...on SearchConfluencePageBlogAttachment{entityId,excerpt,isVerified,lastModified,space{id,spaceId,name,key,webUiLink},confluenceEntity{__typename,...on ConfluencePage{id,type,subtype@include(if:$isLivePagesEnabled),ancestors{title,id,links{webUi}},metadata{titleEmojiPublished{id,key,value}}},...on Node{__isNode:__typename,id}}},...on SearchConfluenceSpace{entityId,key,iconPath,webUiLink}}},pageInfo{endCursor},abTest{abTestId,controlId,experimentId},totalCount}}}"
  }
};
})();

(node as any).hash = "fdb63333f98d16f9fffdf0161967f496";

export default node;
